import { Link } from "react-router-dom";
import { Instagram, Twitter, Globe, Music2, Youtube, Phone, CalendarCheck } from "lucide-react";

function Tile({ href, icon: Icon, label, testId, external = true }) {
  if (!href) return null;
  const props = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <a href={href} {...props} className="flex items-center gap-3 p-4 border border-white/10 hover:border-pfc-gold transition" data-testid={testId}>
      <Icon className="text-pfc-gold" size={18} />
      <span className="font-body text-white/80">{label}</span>
    </a>
  );
}

export default function ProfileConnect({ profile }) {
  const igHandle = profile.instagram?.replace("@", "");
  const twHandle = profile.twitter?.replace("@", "");
  const cleanWebsite = profile.website?.replace(/^https?:\/\//, "");
  const phoneDigits = profile.phone?.replace(/[^0-9+]/g, "");

  return (
    <div className="space-y-3">
      <div className="label text-pfc-gold mb-4">Connect</div>

      {profile.booking_url && (
        <a
          href={profile.booking_url}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center font-sub uppercase tracking-[0.2em] text-xs px-6 py-4 bg-pfc-gold text-ink-900 hover:bg-pfc-gold-bright transition flex items-center justify-center gap-2"
          data-testid="profile-book-btn"
        >
          <CalendarCheck size={16} /> Book Now
        </a>
      )}

      <Tile href={igHandle ? `https://instagram.com/${igHandle}` : null} icon={Instagram} label={profile.instagram} testId="profile-instagram" />
      <Tile href={twHandle ? `https://twitter.com/${twHandle}` : null} icon={Twitter} label={profile.twitter} />
      <Tile href={cleanWebsite ? `https://${cleanWebsite}` : null} icon={Globe} label={profile.website} />
      <Tile href={profile.apple_music_url} icon={Music2} label="Apple Music" testId="profile-apple-music" />
      <Tile
        href={profile.youtube_video_id ? `https://youtu.be/${profile.youtube_video_id}` : null}
        icon={Youtube}
        label="Watch on YouTube"
      />
      <Tile
        href={phoneDigits ? `tel:${phoneDigits}` : null}
        icon={Phone}
        label={profile.phone}
        testId="profile-phone"
        external={false}
      />

      <Link
        to="/contact"
        className="block mt-6 text-center font-sub uppercase tracking-[0.2em] text-xs px-6 py-4 border border-white/20 text-white hover:border-pfc-gold hover:text-pfc-gold transition"
        data-testid="profile-contact-btn"
      >
        Send a Message
      </Link>
    </div>
  );
}
